import { news } from '@/configs/translates.config'

export default {
	'home-page': 'Home page',
	'news-page': `${news.en.plural} page`,
	'seo-fields': 'SEO fields'
}